import { getInsights } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export function useInsights(params: DashboardFilters, isCompanyAdmin?: boolean) {
  const {
    data: insightsData,
    error,
    isPending,
  } = useQuery({
    queryKey: ReactQueryKeys.INSIGHTS(params),
    queryFn: () => getInsights(params),
    enabled: isCompanyAdmin || !!params.company_name,
  });

  return { insightsData, error, isPending };
}
